import React from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import Input from 'components/common/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ProspectForm = ({ company, user }) => {
 const {
  reset,
  watch,
  setValue,
  register,
  handleSubmit,
  formState: { errors }
 } = useForm({ defaultValues: { company, user } });

 const onError = e => console.log(e, 'este es el error que surje');

 const onSubmitData = async data => {
  console.log('se esta enviando el formulario ', data);
  reset();
 };

 return (
  <>
   <Input
    type="text"
    label="Nombre"
    name="name"
    errors={errors}
    formLabelProps={{ className: 'mb-0 fs--2' }}
    formControlProps={{
     ...register('name', { required: true, validate: val => /[A-Za-z.]/.test(val) || 'Ingrese un nombre valido' })
    }}
   />

   <Input
    type="text"
    label="Email"
    name="email"
    errors={errors}
    formLabelProps={{ className: 'mb-0 fs--2' }}
    formControlProps={{
     className: 'input-spin-none',
     ...register('email', {
      required: true,
      pattern: {
       value: /[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})/i,
       message: 'Email invalido'
      }
     })
    }}
   />

   <hr className="border-top border-dashed" />

   <Input
    label="Movil"
    type="tel"
    name="phone"
    errors={errors}
    placeholder="Numero cel"
    formLabelProps={{ className: 'mb-0 fs--2' }}
    formControlProps={{
     type: 'tel',
     autoComplete: 'tel',
     value: watch('phone'),
     onChange: e => setValue('phone', e)
    }}
   />

   <Form.Control
    type="hidden"
    {...register('phone', {
     required: true,
     minLength: { value: 10, message: 'Movil invalido' },
     pattern: { value: /[+0-9]/i, message: 'Solo numeros' }
    })}
   />

   <div className="ps-1 mt-3">
    <Form.Check
     type="switch"
     id="calls"
     label="Recibe llamadas?"
     className="form-label-nogutter"
     name="media.calls"
     checked={true}
     {...register('media.calls')}
    />
    <Form.Check
     type="switch"
     id="whatsapp"
     label="Tiene WhatsApp?"
     className="form-label-nogutter"
     name="media.whatsapp"
     {...register('media.whatsapp')}
    />
    <Form.Check
     type="switch"
     id="telegram"
     label="Tiene Telegram?"
     className="form-label-nogutter"
     name="media.telegram"
     {...register('media.telegram')}
    />
   </div>
   <hr className="border-top border-dashed" />

   <p className="text-danger fs--1 fw-semi-bold">
    <FontAwesomeIcon icon={['far', 'clock']} className="me-2" />
    Seras contactado por un asesor en breve
   </p>
   <Button variant="primary" size="lg" className="w-100 fs-0 mt-1" onClick={() => handleSubmit(onSubmitData, onError)()}>
    Ser Contactado
   </Button>
   <p className="text-700 fw-medium fs--1 mt-3 mb-0">No esperes más. ¡Estás a un Click!</p>
  </>
 );
};

ProspectForm.propTypes = { company: PropTypes.number, user: PropTypes.number };

export default ProspectForm;
